module.exports = __webpack_public_path__ + "static/media/t_cur_01.54d054c5.png";